module.exports = __webpack_public_path__ + "img/img5.a7d44d7d.jpg";